<div class="container">
  <num-search-concept [valueSetUrl]="valueSetUrl" [conceptFilterId]="conceptFilterId">
  </num-search-concept>
  <div class="table-item overflow">
    <num-concept-filter-table
      *ngIf="searchResults$ | async as searchResults"
      [valueSetUrl]="valueSetUrl"
      [conceptFilterId]="conceptFilterId"
    ></num-concept-filter-table>
  </div>
  <div class="staged-concepts-item overflow">
    <num-staged-concepts></num-staged-concepts>
  </div>
</div>
